import instObj from '@/backend/axios-instances'

const resource = "/proposals"
const instance = instObj.baseInstance

export default {
  post(projectId, data) {
    return instance.post(`project/${projectId}${resource}`, data);
  }
}
